type Props = {
  children: React.ReactNode;
};

export default function TableBody({ children }: Props) {
  return (
    <tbody className="bg-gray-background divide-y divide-gray-dark400">
      {children}
    </tbody>
  );
}
